<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <div class="form_title">活动计划基本信息</div>
      <a-row :gutter="24">
        <a-form-item label="活动计划名称" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 21 }">
          <a-input v-decorator="['planName', { rules: [{ required: true, message: '请输入活动计划名称' }] }]"
                   :disabled="index !== 0"
                   :maxLength="50"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-form-item label="活动类型" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-cascader v-decorator="['planType',rules.planType]"
                      placeholder="请选择活动类型"
                      change-on-select
                      :disabled="index !== 0"
                      :options="strainOptions"
                      :fieldNames="{ label: 'typeName', value: 'typeId', children: 'children' }"

          />
        </a-form-item>
      </a-row>
      <!--      <a-row :gutter="24">-->
      <!--        <a-form-item label="品系" :label-col="{ span: 3 }"-->
      <!--                     :wrapper-col="{ span: 4 }">-->
      <!--          <a-select-->
      <!--              :allowClear="true"-->
      <!--              :disabled="index !== 0"-->
      <!--              v-decorator="['strainType', { rules: [{ required: true, message: '请选择品系' }] }]"-->
      <!--              :options="brandData"-->
      <!--              @change="handleStrainType"-->

      <!--          >-->
      <!--          </a-select>-->
      <!--        </a-form-item>-->
      <!--      </a-row>-->
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="活动时间" :label-col="{ span:9 }"
                       :wrapper-col="{ span: 10 }">
            <a-radio-group @change="onChange"
                           :disabled="index !== 0"
                           v-decorator="['planTimeType', { rules: [{ required: true, message: '请选择时间' }] }]">
              <a-radio :value="1">
                季度
              </a-radio>
              <a-radio :value="2">
                月度
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="年份" :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 8 }">
            <a-select
                :allowClear="true"
                :disabled="index !== 0"
                v-decorator="['planYear',{ rules: [{ required: true, message: '请选择年份' }] }]"
                :options="planTimeOptions"
                @change="getYear"
            >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" v-if="years || isShowMonths">
          <a-form-item :label="label" :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 8 }">
            <a-select
                :allowClear="true"
                :disabled="index !== 0"
                v-decorator="['planMonth',{ rules: [{ required: true, message: '请选择' }] }]"
                :options="planMonthOptions"
                @change="getMonth"
            >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!--      <a-row :gutter="24" v-if="index===1">-->
      <!--        <a-form-item label="活动计划数量" :label-col="{ span: 3 }"-->
      <!--                     :wrapper-col="{ span: 4 }">-->
      <!--          <a-input v-decorator="['planDistributeNum', { rules: [{ required: true, message: '请输入活动计划数量' }] }]"-->
      <!--                   :disabled="index !== 0"-->
      <!--                   :maxLength="18" type="number" min="0"/>-->
      <!--        </a-form-item>-->
      <!--      </a-row>-->
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="牵引数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['qyNum', { rules: [{ required: true, message: '请输入牵引数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="载货数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['zhNum', { rules: [{ required: true, message: '请输入载货数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="工程数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['gcNum', { rules: [{ required: true, message: '请输入工程数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="专用数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['zyNum', { rules: [{ required: true, message: '请输入专用数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="轻卡数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['qkNum', { rules: [{ required: true, message: '请输入轻卡数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>
      <a-row :gutter="24" v-if="index===1">
        <a-form-item label="新能源数量" :label-col="{ span: 3 }"
                     :wrapper-col="{ span: 4 }">
          <a-input v-decorator="['xnyNum', { rules: [{ required: true, message: '请输入新能源数量' }] }]"
                   :disabled="index !== 0"
                   default="0"
                   :maxLength="18" type="number" min="0"/>
        </a-form-item>
      </a-row>

    </a-form>

    <div class="table_box">
      <div class="form_title">添加接收部门</div>
      <a-row :gutter="24" v-if="navSwitch !== 2">
        <a-col :span="8">
          <a-form-item label="" :label-col="{ span:2 }"
                       :wrapper-col="{ span: 17 }">
            <a-radio-group v-model="deptName" @change="reSetData">
              <a-radio :value="1" v-if="navSwitch !== 1">
                经理部
              </a-radio>
              <a-radio :value="2">
                经销商
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="tool_bar">
        <vxe-button style="position: absolute;right: 100px;top: 40px;z-index: 999" @click="download(2)">
          部门导入模板下载
        </vxe-button>
        <!--        <vxe-button style="position: absolute;right: 100px;top: 40px;z-index: 999" @click="download(1)">-->
        <!--          人员导入模板下载-->
        <!--        </vxe-button>-->
        <a-upload
            name="file"
            :multiple="false"
            :accept="'.xlsx'"
            :action="api"
            :headers="{token:token}"
            @change="importHandleChange"
        >
          <vxe-button style="position: absolute;right: 20px;top: 40px;z-index: 999">导入</vxe-button>
        </a-upload>
      </div>
      <a-tabs>
        <a-tab-pane key="1" :forceRender="true" tab="">
          <managerProp ref="managerProp"
                       v-if="hasLoaded"
                       :rowId="rowId"
                       :navSwitch="navSwitch"
                       :deptId="deptId"
                       :tabsFlag="deptName"
                       @setTable="setTable"></managerProp>
        </a-tab-pane>
        <!--      <a-tab-pane key="2" tabs="" :forceRender="true" v-if="tabsFlag == 1">-->
        <!--        <dealerProp ref="dealerProp" :rowId="rowId"></dealerProp>-->
        <!--      </a-tab-pane>-->
      </a-tabs>
    </div>

    <a-space class="a-form-btn-box">
      <a-button @click="close()">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
  <!-- 详情页 -->
</template>
<script>
import {formMixin, fmt, loadBaseCodeData, XEUtils} from '@/utils/common/FormBase'

console.log(formMixin, fmt, loadBaseCodeData)
//厂商用户管理接口
import {dataApi} from '@/services/plan/activityPlan.js';
// import XEUtils from "xe-utils";
import managerProp from "@/pages/web/activity/plan/detail/managerProp";
// import dealerProp from "@/pages/web/activity/plan/detail/dealerProp";
import api from "@/services/api";
import axios from "axios";

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    planType: {
      rules: [{required: false, message: "请选择活动类型"},
        {validator: activityTypeRule}]
    },
  };
}

function activityTypeRule(rule, value, callback) {
  // if (value.length === 1) {
  // callback("一级节点不能选择")
  // } else {
  callback()
  // }
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    planTimeType: 1,
    deptName: 0,
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId, this.navFlag);
  if (entity.data.entity.planType) {
    entity.data.entity.planType = XEUtils.findTree(this.strainOptions, item => item.typeId === entity.data.entity.planType).nodes.map(item => item.typeId);
  } else {
    entity.data.entity.planType = [entity.data.entity.planType]
  }

  console.log(entity.data.entity.planType)
  this.oldYear = entity.data.entity.planYear;
  this.oldMonth = entity.data.entity.planMonth;
  this.oldSeason = entity.data.entity.planTimeSeason;
  this.oldStartTime = entity.data.entity.planStartTime;
  this.oldEndTime = entity.data.entity.planEndTime;
  this.deptId = entity.data.entity.receiveDept ? entity.data.entity.receiveDept : 0;
  this.strainId = entity.data.entity.strainType;
  // this.theList = entity.data.list;
  this.zhNum = entity.data.entity.zhNum;
  this.qyNum = entity.data.entity.qyNum;
  this.gcNum = entity.data.entity.gcNum;
  this.zyNum = entity.data.entity.zyNum;
  this.qkNum = entity.data.entity.qkNum;
  this.xnyNum = entity.data.entity.xnyNum;
  this.isShowMonths = entity.data.entity.planTime
  let entityYear = '', entityMonth = '';
  if (entity.data.entity.planTimeType == 1) {
    entityYear = entity.data.entity.planYear;
    entity.data.entity.planYear = entityYear.split('-')[0];
    entity.data.entity.planMonth = entity.data.entity.planTime.slice(-4);
  } else {
    entityMonth = entity.data.entity.planMonth;
    console.log(entityMonth)
    entity.data.entity.planYear = entityMonth.split('-')[0];
    entity.data.entity.planMonth = entityMonth.split('-')[1];
    this.label = '月份';
  }
  if (entity.data.entity.receiveDeptType) {
    this.deptName = entity.data.entity.receiveDeptType
  }
  if (this.navSwitch === 1) {
    this.deptName = 2
  } else if (this.navSwitch === 2) {
    this.deptName = 3
  }
  entity.data = entity.data.entity
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
async function afterLoad(entity) {
  console.log(entity);
  this.hasLoaded = true
  if (this.keyId) {
    let res = await dataApi.getFormDetail(this.keyId, this.navFlag)
    console.log(res);
    this.setRefsValue({
      managerProp: res.data.list,
    })
  }
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  console.log(327, vm);
  let data = {};
  data.entity = entities;
  entities['planMonth'] = this.planMonth;
  entities['planYear'] = this.planYear + '';
  entities['planMold'] = 1;
  entities['receiveDeptType'] = this.deptName;
  entities['planTimeSeason'] = this.planTimeSeason;
  entities['createType'] = this.navSwitch;
  entities.planType = Number(entities.planType.split(',')[entities.planType.split(',').length - 1])

  // if(this.planId){
  //其他数据处理 类似子表放在这里
  vm.$refs["managerProp"].getChildData((child, del) => {
    data.dtlList = child;
    data.delList = del.map(val => {
      return val.id;
    });
  });
  if (data.dtlList.length <= 0) {
    throw '请填写需要下发的数据';
  } else {
    data.dtlList.forEach((item, index) => {
      if ((!item.zhNum) && (!item.qyNum) && (!item.gcNum) && (!item.zyNum) && (!item.qkNum) && (!item.xnyNum)) {
        throw '第' + (index + 1) + '行数据【' + item.deptName + '】的数量不能全为0';
      }
    })
  }

  if (this.index == 1) {  //下发
    entities['planMonth'] = this.oldMonth;
    entities['planYear'] = this.oldYear;
    entities['planId'] = vm.keyId;
    entities['planTimeSeason'] = this.oldSeason;
    entities['planStartTime'] = this.oldStartTime;
    entities['planEndTime'] = this.oldEndTime;
    // let sumCount = 0;
    let zhsumCount = 0;
    let qysumCount = 0;
    let gcsumCount = 0;
    let zysumCount = 0;
    let qksumCount = 0;
    let xnysumCount = 0;

    for (let i = 0; i < data.dtlList.length; i++) {
      // sumCount += parseInt(data.dtlList[i].planDistributeNum);
      if (data.dtlList[i].qyNum) {
        qysumCount += parseInt(data.dtlList[i].qyNum);
      }
      if (data.dtlList[i].zhNum) {
        zhsumCount += parseInt(data.dtlList[i].zhNum);
      }
      if (data.dtlList[i].gcNum) {
        gcsumCount += parseInt(data.dtlList[i].gcNum);
      }
      if (data.dtlList[i].zyNum) {
        zysumCount += parseInt(data.dtlList[i].zyNum);
      }
      if (data.dtlList[i].qkNum) {
        qksumCount += parseInt(data.dtlList[i].qkNum);
      }
      if (data.dtlList[i].xnyNum) {
        xnysumCount += parseInt(data.dtlList[i].xnyNum);
      }
      console.log('for里面的')
      console.log('zhsumCount==============================' + zhsumCount)
      console.log('qysumCount==============================' + qysumCount)
      console.log('gcsumCount==============================' + gcsumCount)
      console.log('zysumCount==============================' + zysumCount)
      console.log('qksumCount==============================' + qksumCount)
      console.log('xnysumCount==============================' + xnysumCount)

    }
    console.log('for外面的')
    console.log('zhsumCount==============================' + zhsumCount)
    console.log('qysumCount==============================' + qysumCount)
    console.log('gcsumCount==============================' + gcsumCount)
    console.log('zysumCount==============================' + zysumCount)
    console.log('qksumCount==============================' + qksumCount)
    console.log('xnysumCount==============================' + xnysumCount)
    // if (sumCount < parseInt(entities.planDistributeNum)) {
    //   throw '下发数量总和不能小于活动活动计划数量'
    // }
    if (qysumCount < parseInt(entities.qyNum)) {
      throw '牵引下发数量总和不能小于牵引计划数量【' + parseInt(entities.qyNum) + '】'
    } else if (zhsumCount < parseInt(entities.zhNum)) {
      throw '载货下发数量总和不能小于载货计划数量【' + parseInt(entities.zhNum) + '】'
    } else if (gcsumCount < parseInt(entities.gcNum)) {
      throw '工程下发数量总和不能小于工程计划数量【' + parseInt(entities.gcNum) + '】'
    } else if (zysumCount < parseInt(entities.zyNum)) {
      throw '专用下发数量总和不能小于专用计划数量【' + parseInt(entities.zyNum) + '】'
    } else if (qksumCount < parseInt(entities.qkNum)) {
      throw '轻卡下发数量总和不能小于轻卡计划数量【' + parseInt(entities.qkNum) + '】'
    } else if (xnysumCount < parseInt(entities.xnyNum)) {
      throw '新能源下发数量总和不能小于新能源计划数量【' + parseInt(entities.xnyNum) + '】'
    }
    return await dataApi.saveProvideDetail(data);
  } else if (this.index == 2) { //更新
    entities['planMonth'] = this.oldMonth;
    entities['planYear'] = this.oldYear;
    entities['planId'] = vm.keyId;
    entities['planTimeSeason'] = this.oldSeason;
    entities['planStartTime'] = this.oldStartTime;
    entities['planEndTime'] = this.oldEndTime;
    return await dataApi.upDateFormDetail(data);
  } else {
    entities['planId'] = ''
    return await dataApi.saveFormDetail(data); //新增保存
  }
  // }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  this.brandData = await loadBaseCodeData('CD200007')
  let commCodeData = await dataApi.getCommCode();
  let activityType = await dataApi.activityType();
  // strainOptionsthis. = activityType.data;
  this.strainOptions = XEUtils.toArrayTree(activityType.data, {
    key: 'typeId',
    parentKey: 'parentId',
    children: 'children'
  })
  console.log(this.strainOptions)
  this.brandData = commCodeData.data.strain.map(v => {
    return {
      label: v.code_name,
      value: v.code_id
    }
  })
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    managerProp,
    // dealerProp,
  },
  props: ['navFlag', 'index', 'navSwitch', 'disabledDetail', 'strainIdId'],
  data() {
    return {
      hasLoaded: false,
      isblank: true,
      // importList: [],
      theList: [],
      mode: 'time',
      strainOptions: [],
      custData: '',
      deptData: '',
      deptId: 0,
      brandData: [],
      planTime: '',
      planYear: '',
      planTimeSeason: '',
      planMonth: '',
      planFlag: '',
      deptName: 1,
      alreadyNum: 0,
      token: localStorage.getItem('token'),
      // api: api.plan.IMPORTTABLE + 1 + '/' + this.navFlag,
      api: api.plan.IMPORTTABLE + 1 + '/' + this.navFlag,

      // api: this.navSwitch !=== 0 ? (api.plan.IMPORTTABLE + 1 + '/' + this.navFlag + '?strainId=' + this.strainIdId) : (api.plan.IMPORTTABLE + 1 + '/' + this.navFlag),
      planTimeOptions: [],
      planMonthOptions: [],//季度或年份数据
      label: '季度',
      Months: '',
      years: '',
      editList: [],
      oldYear: '',
      oldMonth: '',
      oldSeason: '',
      oldEndTime: '',
      oldStartTime: '',
      strainId: '',
      timeType: 1,//时间类型
      isShowMonths:'',//是否显示季度或月的选择框
    }
  },
  computed: {},
  watch: {},
  mounted() {

    this.assembleDate();
    this.getQuarter()//获取季度

  },
  methods: {
    loadEntity,
    newEntity,
    save,
    activityTypeRule,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    selChange(value) {
      console.log(value)
    },
    handleOpenChange(open) {
      console.log(open)
      if (open) {
        this.mode = 'time';
      }
    },
    handlePanelChange(value, mode) {
      console.log(value)
      this.mode = mode;
    },
    //年份下拉
    assembleDate() {
      let date = new Date;
      let y = date.getFullYear()
      for (let i = y; i < 2051; i++) {
        let obj = {};
        obj['label'] = i;
        obj['value'] = i;
        this.planTimeOptions.push(obj);
      }
    },
    getYear(val) {
      this.years = val;
      if (this.months){
        this.setFormValue({planMonth: ''})
      }
      if (this.timeType == 1) {
        this.getQuarter();//获取当前季度
      } else {
        this.getNewmonthList()
      }

      if (this.planFlag == 0) {
        this.planYear = val;
        this.planMonth = '';
      } else {
        this.planMonth = val + '-' + this.months;
      }
    },
    getMonth(val) {
      this.months = val;
      if (this.planFlag == 0) {
        this.planTimeSeason = val;
      } else {
        this.planMonth = this.years + '-' + val;
      }
    },
    // 获取当前季度及之后的数据
    getQuarter() {
      this.planMonthOptions = []
      let date = new Date();
      let y = date.getFullYear()
      if (this.years === y) { //如果选择当前年 那要判断不能选当前季度之前的季度
        var month = date.getMonth() + 1;//getMonth返回0-11
        console.log(610, month);
        if (month >= 1 && month <= 3) {
          this.planMonthOptions = [
            {
              label: '第一季度',
              value: 1
            },
            {
              label: '第二季度',
              value: 2
            },
            {
              label: '第三季度',
              value: 3
            },
            {
              label: '第四季度',
              value: 4
            }
          ]
        } else if (month >= 4 && month <= 6) {
          this.planMonthOptions = [
            {
              label: '第二季度',
              value: 2
            },
            {
              label: '第三季度',
              value: 3
            },
            {
              label: '第四季度',
              value: 4
            }
          ]
        } else if (month >= 7 && month <= 9) {
          this.planMonthOptions = [
            {
              label: '第三季度',
              value: 3
            },
            {
              label: '第四季度',
              value: 4
            }
          ]
        } else {
          this.planMonthOptions = [
            {
              label: '第四季度',
              value: 4
            }
          ]
        }
      } else {
        this.planMonthOptions = [
          {
            label: '第一季度',
            value: 1
          },
          {
            label: '第二季度',
            value: 2
          },
          {
            label: '第三季度',
            value: 3
          },
          {
            label: '第四季度',
            value: 4
          }
        ]
      }
    },
    //获取月份数据
    getNewmonthList() {
      this.planMonthOptions = []
      for (let i = 0; i < 12; i++) {
        if (i < 9) {
          let obj = {};
          obj['label'] = '0' + (i + 1);
          obj['value'] = '0' + (i + 1);
          this.planMonthOptions.push(obj);
        } else {
          let obj = {};
          obj['label'] = i + 1;
          obj['value'] = i + 1;
          this.planMonthOptions.push(obj);
        }
      }
      // 月份只能是当前月及之后的
      var date = new Date();
      let y = date.getFullYear()
      if (this.years === y) {
        var month = date.getMonth();
        this.planMonthOptions.splice(0, month)
      }

    },
    onChange(e) {
      if (this.months){
        this.setFormValue({planMonth: ''})
      }
      this.timeType = e.target.value
      if (this.timeType == 1) {
        this.planFlag = 0;
        this.label = '季度';
        this.planMonthOptions = [];
        this.getQuarter();//获取当前季度
      } else {
        this.planFlag = 1;
        this.label = '月份';
        this.planMonthOptions = [];
        this.getNewmonthList() //月份
      }
    },
    // 下载模板
    download(type) {
      let fileUrl = '', fname = '';
      if (type === 1) {
        fileUrl = 'departmentExample1.xlsx';//人员模板
        fname = '人员导入模板';//人员模板
      } else {
        fileUrl = 'departmentExample2.xlsx';//部门模板
        fname = '部门导入模板';//人员模板
      }
      axios.get(fileUrl, {   //静态资源文件夹public
        responseType: 'blob',
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        fname += '.xls';
        link.href = url;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.log('error:' + JSON.stringify(error))
      });
    },
    // 导入 经销商 IMPORTTABLE
    async importHandleChange({file}) {
      if (file.status === 'done') {
        if (file.response.data.filePath) {
          console.log('error', file)
          this.$message.error('导入数据不规范,示范文件下载中...')
          let downFile = api.clue.ERROREXCEL + 'error/' + file.response.data.filePath + "?download=1";

          if (file.response.data.returnList) {
            let importList = file.response.data.returnList
            this.isblank = false
            for (let i = 0; i < importList.length; i++) {
              this.theList.push(importList[i])
            }
            this.setRefsValue({
              managerProp: this.theList
            })
          }
          // let name1 = file.response.msg.split('.')[0];
          // let len = name1.split('/').length;
          // let name1Arr = name1.split('/');
          // let names = name1Arr[len-2];
          // let downloadElementEF = document.createElement("a");
          // console.log(downloadElementEF)
          // // let href = window.URL.createObjectURL(downFile); //创建下载的链接
          // downloadElementEF.href = downFile;
          // downloadElementEF.download = names + '导入校验失败数据.xlsx'; //下载后文件名
          // document.body.appendChild(downloadElementEF);
          // downloadElementEF.click(); //点击下载
          // document.body.removeChild(downloadElementEF); //下载完成移除元素
          axios.get(downFile, {responseType: "blob"})
              .then((res) => {
                const blob = new Blob([res.data], {
                  type: "application/vnd.ms-excel;charset=utf-8",
                });
                const href = window.URL.createObjectURL(blob);
                const downloadElement = document.createElement("a");
                downloadElement.href = href;
                var name = res.headers["content-disposition"];
                downloadElement.download = decodeURI(name.substring(name.lastIndexOf("=") + 1));
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
              }).catch((fail) => {
            console.error(fail);
          });
          // window.URL.revokeObjectURL(href); //释放掉blob对象
        } else {
          console.log('success', file)
          let importList = file.response.data.returnList
          for (let i = 0; i < importList.length; i++) {
            this.theList.push(importList[i])
          }
          this.setRefsValue({
            managerProp: this.theList
          })
          this.$message.success('导入成功')
        }
        this.showImportPop = false;
        this.refresh();
      }
    },
    deleteRowList() {

    },

    parentFn(payload) {
      this.alreadyNum = payload;
    },
    // handleStrainType(value) {
    //   this.strainId = value;
    //   this.setRefsValue({
    //     // managerProp: this.editList = [],
    //     managerProp: this.theList = [],
    //     // managerProp: [],
    //   })
    // },
    async setTable(res) {
      res.forEach(item => {
        item['planId'] = this.planId
      })

      let editData = {};
      // if (!this.strainId) {
      //   this.$message.warn('请选择品系')
      //   return false;
      // }
      editData = await dataApi.getEditData(res, this.navFlag);
      for (let i = 0; i < editData.data.length; i++) {
        console.log('editData.data[i]================================' + editData.data[i] + '下行')
        console.log(editData.data[i])
        console.log('this.theList================================' + this.theList + '下行')
        console.log(this.theList)
        // editData.data[i].indexOf(this.theList)
        // if (editData.data[i].indexOf(this.theList)===-1) {
        this.theList.push(editData.data[i])
        // }
      }
      this.setRefsValue({
        managerProp: this.theList,

      })
    },
    //重新加载数据
    reSetData() {
      this.setTable([]);
      this.editList = [];
      this.theList = [];
    }
  }
}
;
</script>

<style scoped lang="stylus">
/deep/ .vxe-toolbar {
  height 10px
}

/deep/ .ant-col-3 {
  text-align: left;
  text-overflow: ellipsis; /* 加上，显示省略号*/
  white-space: nowrap;
  overflow: hidden;
  z-index: 100;
}

/deep/ .ant-col-3:hover {
  /* 鼠标滑过  显示隐藏的内容  伴有横向的滚动条 */
  //overflow: auto;
  text-overflow: clip;
}

/deep/ .ant-col-9 {
  text-align: left;
  text-overflow: ellipsis; /* 加上，显示省略号*/
  white-space: nowrap;
  overflow: hidden;
  z-index: 100;
}

/deep/ .ant-col-9:hover {
  /* 鼠标滑过  显示隐藏的内容  伴有横向的滚动条 */
  //overflow: auto;
  text-overflow: clip;
}

/deep/ .ant-tabs-bar.ant-tabs-top-bar {
  padding-bottom 0;
  height: 0
}

/deep/ .ant-tabs-nav-container {
  height: 0
}

/deep/ .already_num {
  position absolute;
  right 100px;
  top 330px;
  z-index: 9;
}

/deep/ .tool_bar {
  position relative;
}

/deep/ .ant-upload-list {
  width: 850px
}
</style>
